import { render } from "./SubmitFilesModal.vue?vue&type=template&id=1e56990b"
import script from "./SubmitFilesModal.vue?vue&type=script&lang=js"
export * from "./SubmitFilesModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__